import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: boolean = false;

const loadingSlice = createSlice({
  initialState,
  name: "loading",
  reducers: {
    setLoading: (state: boolean, action: PayloadAction<boolean>) => {
      return action.payload;
    },
  },
});

export const { setLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
